// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"g","attrs":{"id":"correct"},"children":[{"tag":"path","attrs":{"id":"fill1","fill":"props.fillColor1","d":"M20.9858 8.75736L15.5312 3.30273L7.28857 11.5454L12.7432 17L20.9858 8.75736Z"}},{"tag":"path","attrs":{"id":"stroke1","stroke":"props.strokeColor1","d":"M7.2888 11.5454L3.16748 15.6667L8.6292 21.1284L12.7434 17M7.2888 11.5454L15.5314 3.30273L20.9861 8.75736L12.7434 17M7.2888 11.5454L12.7434 17","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}},{"tag":"path","attrs":{"id":"stroke2","stroke":"props.strokeColor2","d":"M21 17H19M21 21H14","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}}]}]};

const CorrectIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'correct',
    ref,
    icon: element,
  },
));

CorrectIcon.displayName = 'CorrectIcon';

export default CorrectIcon;
